import { Controller } from "stimulus";

export default class extends Controller {
    static targets = [ "message" ]
  connect() {
      if(this.element.clientHeight >= this.element.scrollHeight) {
        this.messageTarget.classList.add('hidden');
      }
  }
}